// EndpointProvider rejects failed requests with the raw response text; the
// prefetch endpoints return {error_code, message} JSON bodies. Returns the
// human-readable message either way.
export const parsePrefetchError = (reason: unknown): string => {
	if (typeof reason === "string") {
		try {
			const parsed = JSON.parse(reason)
			if (typeof parsed?.message === "string") {
				return parsed.message
			}
		} catch {
			// Not JSON — fall through to the raw text.
		}
	}

	return String(reason)
}
